import React from 'react';
import { IMAGES_REPO } from '../../../config';

const ComponentView = (props) => {
  const { isSelected, title, image } = props;
  return (
    <div className={isSelected ? 'service-view service-view--selected' : 'service-view'}>
      <div className="service-view__title">
        <h2>{title}</h2>
      </div>
      <div className="service-view__image-container">
        <img src={IMAGES_REPO + '' + image}/>
      </div>
    </div>
  );
};

export default ComponentView



// WEBPACK FOOTER //
// ./src/components/ListEntity/Entities/Service.js